// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fOCM2fSBXHu1Vu0gd3Qc {
  border: 1px solid #eee;
  padding: 10px;
  box-shadow: 1px 1px 2px #aaa;
  width: 200px;
  height: 200px;
  background-color: #fff;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/components/Spreadsheet/VariablePopover/styles.module.less"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,aAAA;EACA,4BAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AACF","sourcesContent":[".container {\n  border: 1px solid #eee;\n  padding: 10px;\n  box-shadow: 1px 1px 2px #aaa;\n  width: 200px;\n  height: 200px;\n  background-color: #fff;\n  text-align: left;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `fOCM2fSBXHu1Vu0gd3Qc`
};
export default ___CSS_LOADER_EXPORT___;
